<template>
  <div class="pageCount">
    <div class="card-body">
      <template v-if="$i18n.locale == 'tr'">
        Toplam
        <b>{{ total }}</b> adet kayıttan
        <b>{{ skip }}-{{ take }}</b>
        arasındaki kayıtları görüntülemektesiniz.
      </template>

      <template v-else>
        You are viewing records between <b>{{ skip }}-{{ take }}</b> from
        a total of <b>{{ total }}</b> records.
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageCountInfo",
  props: ["total", "skip", "take"],
};
</script>


// WEBPACK FOOTER //
// src/components/PageCountInfo.vue